<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-lg-6 com-md-6 col-sm-12 d-flex justify-content-start"
          ></div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <select class="form-control">
              <option value="">{{ $t('select') }}</option>
            </select>
          </div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'vehicle_zone.zone_name_en'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.operation_date }}</td>
          <td>{{ record.vehicle_profile.plate_no }}</td>
          <td>{{ record.driver.name_en }}</td>
          <td>
            {{
              record.driver_assistance ? record.driver_assistance.name_en : null
            }}
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'vehicleOperation-table',
  data () {
    return {
      loading: false,
      columns: [
        { name: this.$t('vehicleOperation.date') },
        { name: this.$t('vehicleOperation.vehicle') },
        { name: this.$t('vehicleOperation.driver') },
        { name: this.$t('vehicleOperation.driverAssistant') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:1px'
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('vehicleOperation', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.vehicleOperation.search
      },
      set (newValue) {
        this.$store.commit('vehicleOperation/SET_SEARCH', newValue)
        this.$store.commit('vehicleOperation/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('vehicleOperation/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.$store.commit('vehicleOperation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'vehicle-operation-edit',
        params: { id: record.operation_id }
      })
    },

    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('vehicleOperation/destroy', record.operation_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),

    fetch: function () {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
